export default {
  recommendations: state => state.recommendations,
  recommendation: state => state.recommendation
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrate/getters.js